import { ChangeDetectionStrategy, Component, Injector, ViewEncapsulation, inject } from '@angular/core';
import { SiteMapService } from '../site-map.service';
import { ObjectTypes } from '@fi-shared/types/object-type';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { IItemsListAction2 } from '@fi-shared/fi-items-list/fi-items-list';
import { FiRemoteStateFullDataSource } from '@fi-shared/fi-items-list/fi-remote-state-full-data-source';
import { ILoadDataArgs } from '@fi-shared/fi-items-list/fi-data-source-base.directive';
import { UserService } from '@fi-app/user/user.service';
import { FiItemsDeleteHelperService } from '@fi-shared/fi-shared-services/fi-items-delete-helper.service';
import { FiItemsListType } from '@fi-shared/fi-items-list/fi-items-list-type';
import { ISiteMap } from '@fi-shared/models/site-map';

@Component({
    selector: 'fi-site-map-list',
    templateUrl: './site-map-list.component.html',
    styleUrls: ['./site-map-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-site-map-list' },
    standalone: false,
})
export class SiteMapListComponent extends FiRemoteStateFullDataSource<ISiteMap> {
    public defaultSortColumnName = 'ChangedOn';
    public itemsListType = FiItemsListType.SiteMapList;
    public defaultSortDirection;
    public objectType = ObjectTypes.SiteMap;

    private siteMapService = inject(SiteMapService);
    private userService = inject(UserService);
    private fiItemsDeleteHelperService = inject(FiItemsDeleteHelperService);
    protected itemsListActions: IItemsListAction2[] = [
        {
            title: this.appTextService.get('common.delete'),
            onClick: () => {
                this.confirmDeleteSelectedSiteMaps();
            },
        },
    ];

    protected readonly FiStateNames = FiStateNames;

    constructor(injector: Injector) {
        super(injector);
    }

    private confirmDeleteSelectedSiteMaps(): void {
        this.fiItemsDeleteHelperService
            .commonDeleteConfirm(ObjectTypes.SiteMap, this.selectedItems())
            .then(() => this.deleteSelectedSiteMaps())
            .catch(() => {});
    }

    private deleteSelectedSiteMaps(): void {
        const selectedItems = this.selectedItems();
        this.siteMapService
            .deleteSiteMapAction(
                selectedItems.map((item) => item.Id),
                selectedItems,
            )
            .then(() => this.reloadData());
    }

    protected openUserViewDialog($event: MouseEvent, userId: number): void {
        $event.stopPropagation();
        this.userService.openUserViewDialog(userId);
    }

    public loadListDataFn(loadArgs: ILoadDataArgs) {
        const parameter = this.getItemsListParameter(loadArgs);

        parameter.FetchParams = {
            FetchItems: true,
            FetchTotalCount: !loadArgs.fetchOnlyItems,
            FetchLightWeightObjects: !loadArgs.fetchOnlyItems,
        };
        return this.siteMapService.getSiteMapsListData(parameter);
    }
}
